<div
  *ngIf="supportChatService.chat"
  class="popover-chat-container"
  [ngClass]="{ 'chat-visible': supportChatService.isChatVisible }"
>
  <div class="popover-content mobile-fullscrean">
    <div class="mobile-contols">
      <button class="btn btn-back" (click)="toggleChat()">
        <div class="icon icon-bold-arrow-left"></div>
        <span class="btn-text">Back</span>
      </button>
    </div>
    <div class="popover-chat">
      <app-chat

      />
    </div>
  </div>
  <div class="popover-controls"  *ngIf="!hideFeedbackButton">
    <button class="btn btn-feedback" [disabled]="true"  (click)="toggleChat()"> <!-- disabled until the chat is implemented -->
      <div
        [className]="
          supportChatService.isChatVisible ? 'icon-cross' : 'icon-feedback'
        "
      ></div>
    </button>
  </div>
</div>
